import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProblemaPage = lazy(() => import('../pages/problema/page'));
const VertiixPage = lazy(() => import('../pages/vertiix/page'));
const ComeFunzionaPage = lazy(() => import('../pages/come-funziona/page'));
const AccessoPage = lazy(() => import('../pages/accesso/page'));
const ValutazionePage = lazy(() => import('../pages/valutazione/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/problema',
    element: <ProblemaPage />,
  },
  {
    path: '/vertiix',
    element: <VertiixPage />,
  },
  {
    path: '/come-funziona',
    element: <ComeFunzionaPage />,
  },
  {
    path: '/accesso',
    element: <AccessoPage />,
  },
  {
    path: '/valutazione',
    element: <ValutazionePage />,
  },
  {
    path: '/about-vertiix',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
